import React from 'react';
import {
  GDSStyleObject,
  StackItem,
  StackLayout,
} from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';
import { BackButtonArrow } from 'components/back-button-arrow/back-button-arrow.component';

type MasonryPageLayoutProps = {
  showBackButton?: boolean;
  css?: GDSStyleObject;
  children: React.ReactNode;
};

export const MasonryPageLayout = ({
  showBackButton = false,
  css,
  children,
}: MasonryPageLayoutProps) => (
  <StackLayout
    orientation="vertical"
    verticalAlignment="top"
    horizontalAlignment="stretch"
    css={{
      marginX: 'auto',
      padding: '$none $two $three $two',
      maxWidth: CONTENT_MAX_WIDTH,
      '@mobile': {
        padding: '$none $one $two $one',
      },
      '& .masonry-page-header-background': {
        marginBottom: '$two',
        '@desktop': {
          marginBottom: '$twoAndHalf',
        },
        '@laptop': {
          marginBottom: '$twoAndHalf',
        },
      },
      ...css,
    }}
  >
    {showBackButton ? (
      <>
        <BackButtonArrow
          css={{
            zIndex: '$default',
            marginTop: '$one',
            width: 'max-content',
          }}
        />
        <StackItem css={{ position: 'relative' }}>{children}</StackItem>
      </>
    ) : (
      children
    )}
  </StackLayout>
);
